export const compareArrays = (current, updated) => {
    return (current.length === updated.length) &&
        (current.every((id) => updated.indexOf(id) > -1));
};
//# sourceMappingURL=compareArrays.js.map